import { v4 as uuidv4 } from 'uuid'

export const totalStaffTestData = () => {
  return {
    title: 'Total Staff',
    item: '8 Employees',
    key: uuidv4()
  }
}
